(function() { window.GUID_e407f53f_c363_4def_8664_7cc7baf9a5bc = { getGuid: function() { return "e407f53f-c363-4def-8664-7cc7baf9a5bc"; } }; })();
//namespace CS.Controls {
//    export abstract class Container extends ControlBase {
//        private $container: JQuery;
//        public Parameters: any[];
//        public get ControlId(): string {
//            return this.$container.attr('id');
//        }
//        public get $Control(): JQuery {
//            return this.$container;
//        }
//        protected OnControlInstantiation(params: any[]) {
//            this.$container = $('#' + params[0]);//contient le Id
//            this.Parameters = params;
//            this.OnControlInstantiated();
//        }
//        public abstract OnControlInstantiated();
//    }
//}

//# sourceMappingURL=container.js.map
